module.exports = __webpack_public_path__ + "static/media/ic_user.85ea440d.svg";